import cleanDeep from "clean-deep";
import apiURL from "./apiURL";
// const apiURL = "http://localhost:3000"
console.log("apiURL2", apiURL);
// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];

// types of action
const Types = {
	TIMESHEETS_GET: "TIMESHEETS_GET",
	TIMESHEETS_PROCESSING: "TIMESHEETS_PROCESSING",
	TIMESHEETS_OPEN_MODAL: "TIMESHEETS_OPEN_MODAL",
	TIMESHEETS_SAVING: "TIMESHEETS_SAVING",
	TIMESHEETS_APPROVED: "TIMESHEETS_APPROVED",
	// TIMESHEETS_UPDATE_CURRENT_TIMESHEET: "TIMESHEETS_UPDATE_CURRENT_TIMESHEET"
	TIMESHEETS_SAVE_CURRENT_TIMESHEET: "TIMESHEETS_SAVE_CURRENT_TIMESHEET",
	TIMESHEETS_SAVING_CURRENT_TIMESHEET: "TIMESHEETS_SAVING_CURRENT_TIMESHEET",
	TIMESHEETS_IMAGE_PREVIEW: "TIMESHEETS_IMAGE_PREVIEW",
	TIMESHEETS_IMAGE_PREVIEW_MODAL: "TIMESHEETS_IMAGE_PREVIEW_MODAL",
	TIMESHEETS_SHOW_COMMENTS: "TIMESHEETS_SHOW_COMMENTS",
};

const timesheetGetData = (response) => ({
	type: Types.TIMESHEETS_GET,
	payload: response,
});

const timesheetGet = ({ from, to, department, agreement, workLocation, status, employmentType }) => {
	return (dispatch, getState) => {
		dispatch(timesheetProcessing(true));

		const qs = new URLSearchParams(
			cleanDeep({ from, to, department, agreement, status, workLocation, employmentType }),
		);
		fetch(apiURL + `/settings/timesheets?${qs}`, {
			// fetch('http://localhost:3000/report/templates' , {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(timesheetGetData(data));
			});
	};
};

// actions
const timesheetSetOpenModal = (status, timesheet, location) => ({
	type: Types.TIMESHEETS_OPEN_MODAL,
	status: status,
	timesheet: timesheet,
	location: location,
});

const timesheetSetSaving = (saving) => ({
	type: Types.TIMESHEETS_SAVING,
	saving,
});

const timesheetUpdateSaveStatus = (response, timesheet) => ({
	type: Types.TIMESHEETS_SAVE_CURRENT_TIMESHEET,
	payload: response,
	timesheet,
});

const timesheetProcessing = (status) => ({
	type: Types.TIMESHEETS_PROCESSING,
	status,
});

const timesheetSave = (timesheet) => {
	return (dispatch, getState) => {
		dispatch(timesheetSetSaving(false));

		fetch(apiURL + `/settings/timesheets`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({ timesheets: [timesheet] }),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.log("entity data", data);
				dispatch(timesheetUpdateSaveStatus(data, timesheet));
			});
	};
};

const timesheetsApproved = (response, timesheets) => ({
	type: Types.TIMESHEETS_APPROVED,
	payload: response,
	timesheets,
});

const approveTimesheets = (timesheets, processingCallback) => {
	return (dispatch, getState) => {
		timesheets.map((t) => (t.status = "Approved"));

		fetch(apiURL + `/settings/timesheets`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({ timesheets }),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.log("entity data", data);
				dispatch(timesheetsApproved(data, timesheets));
				processingCallback(false);
			});
	};
};

const timesheetImagePreview = ({ processing, image }) => ({
	type: Types.TIMESHEETS_IMAGE_PREVIEW,
	processing,
	image,
});

const timesheetImagePreviewModal = ({ status, image }) => ({
	type: Types.TIMESHEETS_IMAGE_PREVIEW_MODAL,
	status,
	image,
});

const timesheetGetPreview = (fileKey, regularTimesheet) => {
	return (dispatch, getState) => {
		const state = getState();

		const thisImage = state.timesheets.images.find((i) => i.fileKey === fileKey);

		console.log({ thisImage });
		if (thisImage && new Date().toISOString() < thisImage.expires) {
			dispatch(timesheetImagePreviewModal({ status: true, image: thisImage }));
		} else {
			let qs;
			if (regularTimesheet) qs = new URLSearchParams({ regularTimesheet });
			dispatch(timesheetImagePreview({ processing: fileKey }));
			fetch(apiURL + `/settings/timesheets/photo/${encodeURIComponent(fileKey)}${qs ? `?${qs}` : ""}`, {
				credentials: "include",
				method: "GET",
				headers: {
					"Accept": "application/json",
					"Content-Type": "application/json",
				},
			})
				.then((res) => res.json())
				.then((data) => {
					console.log(data);
					const image = {
						fileKey,
						url: data.url,
						expires: data.expires,
					};
					dispatch(timesheetImagePreview({ image }));
					dispatch(timesheetGetPreview(fileKey));
				});
		}
	};
};

const showComments = (timesheet) => ({
	type: Types.TIMESHEETS_SHOW_COMMENTS,
	timesheet,
});
/*const selectTrackingCategory = trackingCategory => ({
  type: Types.SELECT_TRACKING_CATEGORY,
  trackingCategory: trackingCategory
});

const selectYear = year => ({
  type: Types.SELECT_YEAR,
  year
});

const updateFacilities = response => ({
  type: Types.GET_FACILITIES,
  payload: response
});

const getFacilities = () => {
  return (dispatch, getState) => {

    fetch(apiURL + `/my/facilities` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Organisation': getState().currentOrganisation,
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(updateFacilities(data))
    })
  }
}*/

const Actions = {
	timesheetSetOpenModal,
	timesheetSave,
	timesheetGet,
	timesheetUpdateSaveStatus,
	timesheetProcessing,
	approveTimesheets,
	timesheetImagePreviewModal,
	timesheetGetPreview,
	showComments,
};

// exports = {
//   Types,
//   Actions
// }

export { Types, Actions };

// exports.Types = Types
// exports.Actions = Actions
